import { Component, OnInit, OnDestroy, ChangeDetectorRef, ViewChild, ViewChildren, inject, signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, Subject, combineLatest, of } from 'rxjs';
import { catchError, map, switchMap, take, takeUntil } from 'rxjs/operators';
import {
  ChannelType,
  ChannelUIds,
  MassNotificationType,
  ChannelsCascadeSettings,
  AllowedTemplateOverrides,
  MassNotificationTemplate,
  MassNotificationTemplateGroup,
  TemplateViewControlType,
  CommunicationTemplate,
  CommunicationTemplateViewControl,
  ConfirmationButton,
  ToRecipientSettings,
  ConfirmationType,
  WhatsAppTemplate
} from 'src/app/modules/communications/store/communications/communications.model';
import * as fromComm from 'src/app/modules/communications/store/communications';
import * as fromRouting from 'src/app/modules/core/store/routing';
import { Workflow, WorkflowParentType } from 'src/app/modules/core/store/models/workflow.model';
import { WorkflowApiService } from '../../../store/workflow/workflow-api.service';
import { QueryParams } from 'src/app/modules/core/store/models/query.model';
import * as fromAuth from 'src/app/modules/authentication/store/auth/auth.selectors';
import produce from 'immer';
import { v4 as uuidv4 } from 'uuid';
import { GUID_EMPTY } from '@app/core/constants';
import { QuillEditorService } from 'src/app/modules/core/services/quill/quill.service';
import { UserProfileApiService } from 'src/app/modules/core/store/user-profile';
import { TemplateDesignElementDirective } from '../../../components/template/designer/design-elements/design-elements.directive';
import { ChannelSelectionService } from '../../../services/channel-selection-service';
import { DEFAULT_APP_CULTURE_CODE } from 'src/app/modules/core/languages/language.model';
import { CultureService } from 'src/app/modules/core/services/culture.service';
import { TemplateDesignerService } from '../../../services/template-designer.service';
import { SelectedElementEvent } from '../../../components/template/designer/design-elements/design-elements.models';
import { TextValueByCulture } from 'src/app/modules/core/store/models/translations.model';
import { ActionMenuComponent } from 'src/app/modules/core/components/action-menu/action-menu.component';
import { cloneDeep } from 'lodash-es';
import { TemplateDesigner } from '../../../components/template/designer/designer/designer.component';
import { TemplateDesignElementsRegistration } from '@app/modules/communications/components/template/designer/design-elements/design-elements.map';
import { OrgBusinessUnitsApiService } from '@app/modules/core/org-business-units/org-business-units-api.service';
import { OrgBusinessUnit } from '@app/modules/core/org-business-units/org-business-unit.model';
import { CommunicationsApiService } from '@app/modules/communications/store/communications/communications-api.service';
import { UserContext } from '@app/modules/authentication/store/auth';
import equal from 'fast-deep-equal';
import { UserContextService } from '@app/modules/core/services/user-context.service';
@Component({
  selector: 'topo-comms-template-edit',
  templateUrl: './template-edit.component.html',
  styleUrls: ['./template-edit.component.scss'],
  standalone: false
})
export class TemplateEditComponent implements OnInit, OnDestroy {
  settingsTabs: string[] = [];
  notificationTabs: string[] = [];
  contentTabs: string[] = [];
  contentTabIcons: string[] = [];
  contentTabChannels: { channelUId: string; channelType: ChannelType; icon: string; templateUId?: string }[] = [];

  @ViewChild('actions') actionsMenu: ActionMenuComponent;
  @ViewChild('designer') designer: TemplateDesigner;
  @ViewChildren(TemplateDesignElementDirective) designControls;

  ChannelUIds = ChannelUIds;
  isActive: boolean;
  isDirty: boolean;
  isDrawerOpen: boolean;
  isHidden: boolean;
  isTemplateActive: boolean;
  createdOn: string;
  updatedOn: string;
  selectedTabIndex = 0;
  selectedNotificationTabIndex = 0;
  selectedContentTabIndex = 0;
  MassNotificationType = MassNotificationType;
  editor: any;
  userContext: UserContext;
  organizationUId: string;
  enableDrag: boolean = true;
  showEmailSubject: boolean;
  showPushTitle: boolean;
  showPushSummary: boolean;
  recipientsSelectionActive: boolean;
  isConfirmWarning: boolean;
  isClosing: boolean;
  saveMenuOpen: boolean;
  languages: string[];
  mainTabIndex = 0;
  singleMessageMode: boolean = true;
  userToggledSingleMessageMode = false;
  isSmsOverLimitReached: boolean = false;

  template: MassNotificationTemplate;
  selectedTemplateType: MassNotificationType;
  selectedNotificationWorkflowTemplateUId: string;
  selectedRecipientWorkflowTemplateUId: string;
  selectedTemplateGroupUId: string;
  selectedTemplateGroup: MassNotificationTemplateGroup;

  notificationWorkflowTemplates: Workflow[];
  recipientWorkflowTemplates: Workflow[];
  templateGroups: MassNotificationTemplateGroup[];
  selectedCommunicationTemplate: CommunicationTemplate;

  selectedDefaultMessage: string;
  selectedDefaultSmsMessage: string;
  selectedConfirmationMessage: string;
  confirmationButtons: { uId: string; number: number; type: ConfirmationType; text: string }[];
  emailSubject: string;
  pushTitle: string;
  pushSummary: string;
  messageCharCount: number;
  smsMessageCharCount: number = 0;
  whatsAppTemplates: WhatsAppTemplate[];

  confirmationOptions: { uId: string; name: string }[] = [];

  ConfirmationType = ConfirmationType;

  disabledElementTypes: TemplateViewControlType[];

  templateTypes = [MassNotificationType.Announcement, MassNotificationType.SafetyCheck];

  allAllowedChangesForChannels: AllowedTemplateOverrides = AllowedTemplateOverrides.Channels;

  canChangeChannels: boolean;
  canChangeCascade: boolean;
  canChangeSendTime: boolean;
  canChangeResendTime: boolean;
  canChangeExpiration: boolean;
  canChangeMessage: boolean;
  canChangeRecipients: boolean;

  templateName: string;
  templateDesc: string;
  selectedCulture: string;
  selectedWhatsAppTemplate: WhatsAppTemplate;
  selectedWhatsAppMessage: string;

  currentChannelName: string;
  currentElementName: string;
  currentControlToEdit: CommunicationTemplateViewControl = null;
  editableControlTypes: TemplateViewControlType[] = [TemplateViewControlType.Image, TemplateViewControlType.Text];
  showConfirmClose: boolean;
  validationMessage: string;
  validationList: any;
  showConfirmValidation: boolean;
  hasSMSMessage: boolean;
  hasHTMLMessage: boolean;
  destroy$ = new Subject<void>();
  defaultWhatsAppTemplate = 'd98f33b6-edd0-46f4-9442-a791f3225009';
  businessUnits: OrgBusinessUnit[];
  hasBusinessUnits: boolean;
  selectedUnitUIds = [];
  rootUnitUId: string;
  singleSmsLimit: any = 277;
  absoluteMaxLimit: any = 277;
  warningThreshold: any = 161;
  blockInput: boolean = true;
  maxChars = this.templateDesignerService.MAX_CHARS;
  progressPercentage = 0;
  showWarning = false;
  smsCount: number;
  isSmsOverLimit: boolean;
  readonly MAX_CHARS = 277;
  isSmsOverLimitReached$ = new BehaviorSubject<boolean>(false);
  preventSavingTemplate = false;

  private userContextService = inject(UserContextService);

  constructor(
    private store: Store<any>,
    private translateService: TranslateService,
    private workflowApiService: WorkflowApiService,
    private editorService: QuillEditorService,
    private userProfileApiService: UserProfileApiService,
    private channelSelectionService: ChannelSelectionService,
    private templateDesignerService: TemplateDesignerService,
    private cultureService: CultureService,
    private cdr: ChangeDetectorRef,
    private orgBusinessUnitsApiService: OrgBusinessUnitsApiService,
    private commApiService: CommunicationsApiService
  ) {}

  ngOnInit(): void {
    const userContext = this.userContextService.getContext();

    this.userContext = userContext;
    this.organizationUId = userContext.organizationUId;

    // Track both counts
    this.templateDesignerService.currentCount$.subscribe(count => {
      // this.currentCount = count;
      this.progressPercentage = Math.min((count / this.maxChars) * 100, 100);
      this.showWarning = count > this.maxChars;
    });

    this.selectedCulture = this.cultureService.currentLang;
    this.settingsTabs.push(this.translateService.instant('COMMUNICATIONS.TAB-OVERVIEW'));

    this.notificationTabs.push(this.translateService.instant('COMMUNICATIONS.TAB-PROPERTIES'));
    this.notificationTabs.push(this.translateService.instant('COMMUNICATIONS.TAB-CHANNELS-CASCADES'));
    this.notificationTabs.push(this.translateService.instant('COMMUNICATIONS.TAB-RECIPIENTS'));

    this.channelSelectionService.loadAvailableChannels(true);
    this.templateDesignerService.init(true);
    this.singleMessageMode = true;

    this.orgBusinessUnitsApiService.hasOrgBusinessUnits().subscribe(hasBusinessUnits => {
      this.hasBusinessUnits = hasBusinessUnits;
    });

    this.languages = this.cultureService
      .getUserProfile()
      ?.culture?.orgCultures?.split(',')
      ?.filter(c => c?.trim().length > 0);

    this.currentChannelName = null;
    this.currentElementName = this.translateService.instant('COMMUNICATIONS.NOTIFICATION-MESSAGE');

    this.channelSelectionService.channelsLoadedEvents$
      .pipe(
        switchMap(() => this.store.select(fromComm.selectSelectedMassNotificationTemplate)),
        takeUntil(this.destroy$)
      )
      .subscribe(template => {
        const wasActive = this.isActive;
        this.isActive = !!template;
        this.template = cloneDeep(template);

        this.getMessageTypes();
        this.syncContentTabs(this.template);

        this.getSelectedDefaultMessageSettings();

        if (wasActive !== this.isActive) {
          this.isDrawerOpen = true;
          this.templateName = template?.name;
          this.templateDesc = template?.description;
          this.isTemplateActive = template?.isActive === true;
          this.selectedTemplateType = template?.type;
          this.disabledElementTypes =
            this.selectedTemplateType === MassNotificationType.Announcement ? [TemplateViewControlType.ConfirmationMessage] : [];
          this.canChangeChannels = (template?.allowedOverrides & AllowedTemplateOverrides.Channels) === AllowedTemplateOverrides.Channels;
          this.canChangeCascade = (template?.allowedOverrides & AllowedTemplateOverrides.Cascade) === AllowedTemplateOverrides.Cascade;
          this.canChangeSendTime = (template?.allowedOverrides & AllowedTemplateOverrides.SendTime) === AllowedTemplateOverrides.SendTime;
          this.canChangeResendTime =
            (template?.allowedOverrides & AllowedTemplateOverrides.ResendTime) === AllowedTemplateOverrides.ResendTime;
          this.canChangeExpiration =
            (template?.allowedOverrides & AllowedTemplateOverrides.Expiration) === AllowedTemplateOverrides.Expiration;
          this.canChangeMessage =
            (template?.allowedOverrides & AllowedTemplateOverrides.NotificationMessage) === AllowedTemplateOverrides.NotificationMessage;
          this.canChangeRecipients =
            (template?.allowedOverrides & AllowedTemplateOverrides.Recipients) === AllowedTemplateOverrides.Recipients;
          this.selectedNotificationWorkflowTemplateUId = template?.massNotificationWorkflowUId;
          this.selectedRecipientWorkflowTemplateUId = template?.massNotificationRecipientsWorkflowUId;
          this.selectedTemplateGroupUId = template?.templateGroupUId;
          this.selectedTabIndex = 0;
          this.mainTabIndex = 0;
          this.selectedNotificationTabIndex = 0;
          this.selectedContentTabIndex = 0;
          this.showEmailSubject = false;
          this.showPushTitle = false;
          this.showPushSummary = false;

          if (!!this.template) {
            this.populatedDatesForDisplay(this.template);
          }

          if (!!this.userContext) {
            this.orgBusinessUnitsApiService.getOrgBusinessUnitsForUser(this.userContext.userProfileUId).subscribe(businessUnits => {
              this.processBusinessUnits(businessUnits);
            });
          }

          this.loadWorkflowTemplates();

          this.loadTemplateGroups();

          this.syncContentTabs(this.template);
        }
        this.cdr.detectChanges();
        this.isOverTotalLimit();
      });

    this.store
      .select(fromComm.selectIsdMassNotificationTemplatesDirty)
      .pipe(takeUntil(this.destroy$))
      .subscribe(isDirty => {
        this.isDirty = isDirty;
      });
  }

  updateTemplate(updatedTemplate: MassNotificationTemplate): void {
    this.template = updatedTemplate;
    this.isDirty = true;

    this.selectedCommunicationTemplate = this.template?.communicationTemplates?.find(
      c => c.uId === this.contentTabChannels[this.selectedContentTabIndex - 1]?.templateUId
    );

    this.getSelectedDefaultMessageSettings();

    this.isOverTotalLimit();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  navigate(path: string) {
    this.store.dispatch(
      fromRouting.go({
        routeData: { path: [path] }
      })
    );
  }

  private getMessageTypes(): void {
    const uniqueChannelUIds = this.channelSelectionService.getUniqueChannelUIds(this.template?.channelsCascadeSettings);

    this.hasHTMLMessage = uniqueChannelUIds?.some(
      t => t !== ChannelUIds.TwilioChannelUId && t !== ChannelUIds.HorizonSmsChannelUId && t !== ChannelUIds.WhatsAppChannelUId
    );
    this.hasSMSMessage = uniqueChannelUIds?.some(
      t => t === ChannelUIds.TwilioChannelUId || t === ChannelUIds.HorizonSmsChannelUId || t === ChannelUIds.WhatsAppChannelUId
    );
  }

  private processBusinessUnits(businessUnits: OrgBusinessUnit[]): void {
    const rootUnit = businessUnits?.find(u => !!!u.parentUId);
    this.rootUnitUId = null;
    this.selectedUnitUIds = [];
    if (!!rootUnit) {
      rootUnit.name = this.translateService.instant('MANAGEMENT.MENU.GLOBAL-UNIT', { name: rootUnit.name });
      this.rootUnitUId = rootUnit.uId;
    }
    if (!!this.template) {
      if (this.template.businessUnitUIds?.length > 0) {
        this.selectedUnitUIds = this.template.businessUnitUIds.sort((c1, c2) =>
          businessUnits.find(b => b.uId == c1)?.level > businessUnits.find(b => b.uId == c2)?.level ? 1 : -1
        );
      }
    }
    this.businessUnits = businessUnits;
  }

  onBusinessUnitsSelectionChanged(selectedUIds: string[]): void {
    if (!equal(selectedUIds, this.selectedUnitUIds)) {
      this.isDirty = true;
    }
    this.selectedUnitUIds = selectedUIds;
  }

  private populatedDatesForDisplay(template: MassNotificationTemplate): void {
    const format = 'LONG-DATE-WITH-TIME';
    this.createdOn = this.cultureService.getDateDisplay(template.createdOn, format);
    this.updatedOn = this.cultureService.getDateDisplay(template.updatedOn, format);
  }

  getHasSmsChannel(): boolean {
    const uniqueChannelUIds = this.channelSelectionService.getUniqueChannelUIds(this.template?.channelsCascadeSettings);
    return uniqueChannelUIds.some(u => u === ChannelUIds.TwilioChannelUId || u == ChannelUIds.HorizonSmsChannelUId);
  }

  getHasWhatsAppChannel(): boolean {
    const uniqueChannelUIds = this.channelSelectionService.getUniqueChannelUIds(this.template?.channelsCascadeSettings);
    return uniqueChannelUIds.some(u => u === ChannelUIds.WhatsAppChannelUId);
  }

  getHasPushChannel(): boolean {
    const uniqueChannelUIds = this.channelSelectionService.getUniqueChannelUIds(this.template?.channelsCascadeSettings);
    return uniqueChannelUIds.some(u => u === ChannelUIds.HorizonMobilePushChannelUId || u == ChannelUIds.GwtsMobileChannelUId);
  }

  syncContentTabs(template: MassNotificationTemplate): void {
    this.contentTabs = [];
    this.contentTabIcons = [];
    this.contentTabChannels = [];

    this.contentTabs.push(this.translateService.instant('COMMUNICATIONS.TAB-NOTIFICATION-MESSAGE'));
    this.contentTabIcons.push('icon-bullhorn');

    const uniqueChannelUIds = this.channelSelectionService.getUniqueChannelUIds(template?.channelsCascadeSettings);

    let hasEmail = false;
    let hasSlack = false;
    let hasTeams = false;
    let hasSms = false;
    let hasTts = false;
    let hasWhatsapp = false;
    let hasPush = false;
    let hasGwts = false;

    uniqueChannelUIds.forEach(channelUId => {
      if (channelUId === ChannelUIds.TopoEmailChannelUId || channelUId === ChannelUIds.SendGridEmailChannelUId) {
        hasEmail = true;
      } else if (channelUId === ChannelUIds.SlackChannelUId) {
        hasSlack = true;
      } else if (channelUId === ChannelUIds.MicrosoftTeamsChannelUId) {
        hasTeams = true;
      } else if (channelUId === ChannelUIds.TwilioChannelUId || channelUId === ChannelUIds.HorizonSmsChannelUId) {
        hasSms = true;
      } else if (channelUId === ChannelUIds.TwilioTtsChannelUId) {
        hasTts = true;
      } else if (channelUId === ChannelUIds.WhatsAppChannelUId) {
        hasWhatsapp = true;
      } else if (channelUId === ChannelUIds.HorizonMobilePushChannelUId) {
        hasPush = true;
      } else if (channelUId === ChannelUIds.GwtsMobileChannelUId) {
        hasGwts = true;
      }
    });

    if (hasEmail) {
      this.contentTabs.push(this.translateService.instant('COMMUNICATIONS.TAB-EMAIL-TYPE'));
      const templateUId = this.template?.communicationTemplates?.find(
        c =>
          (c.channelUId === ChannelUIds.TopoEmailChannelUId || c.channelUId === ChannelUIds.SendGridEmailChannelUId) &&
          c.channelType === ChannelType.Email
      )?.uId;
      this.contentTabChannels.push({
        channelUId: ChannelUIds.TopoEmailChannelUId,
        channelType: ChannelType.Email,
        icon: this.channelSelectionService.getChannelIcon(ChannelUIds.TopoEmailChannelUId),
        templateUId: templateUId
      });
      this.contentTabIcons.push(this.channelSelectionService.getChannelIcon(ChannelUIds.TopoEmailChannelUId));
    }

    if (hasSlack) {
      this.contentTabs.push(this.translateService.instant('COMMUNICATIONS.TAB-SLACK-TYPE'));
      const templateUId = this.template?.communicationTemplates?.find(
        c => c.channelUId === ChannelUIds.SlackChannelUId && c.channelType === ChannelType.App
      )?.uId;
      this.contentTabChannels.push({
        channelUId: ChannelUIds.SlackChannelUId,
        channelType: ChannelType.App,
        icon: this.channelSelectionService.getChannelIcon(ChannelUIds.SlackChannelUId),
        templateUId: templateUId
      });
      this.contentTabIcons.push(this.channelSelectionService.getChannelIcon(ChannelUIds.SlackChannelUId));
    }

    if (hasTeams) {
      this.contentTabs.push(this.translateService.instant('COMMUNICATIONS.TAB-TEAMS-TYPE'));
      const templateUId = this.template?.communicationTemplates?.find(
        c => c.channelUId === ChannelUIds.MicrosoftTeamsChannelUId && c.channelType === ChannelType.App
      )?.uId;
      this.contentTabChannels.push({
        channelUId: ChannelUIds.MicrosoftTeamsChannelUId,
        channelType: ChannelType.App,
        icon: this.channelSelectionService.getChannelIcon(ChannelUIds.MicrosoftTeamsChannelUId),
        templateUId: templateUId
      });
      this.contentTabIcons.push(this.channelSelectionService.getChannelIcon(ChannelUIds.MicrosoftTeamsChannelUId));
    }

    if (hasSms) {
      this.contentTabs.push(this.translateService.instant('COMMUNICATIONS.TAB-SMS-TYPE'));
      const templateUId = this.template?.communicationTemplates?.find(
        c =>
          (c.channelUId === ChannelUIds.TwilioChannelUId || c.channelUId === ChannelUIds.HorizonSmsChannelUId) &&
          c.channelType === ChannelType.Sms
      )?.uId;
      this.contentTabChannels.push({
        channelUId: ChannelUIds.TwilioChannelUId,
        channelType: ChannelType.Sms,
        icon: this.channelSelectionService.getChannelIcon(ChannelUIds.TwilioChannelUId),
        templateUId: templateUId
      });
      this.contentTabIcons.push(this.channelSelectionService.getChannelIcon(ChannelUIds.TwilioChannelUId));
    }

    if (hasTts) {
      this.contentTabs.push(this.translateService.instant('COMMUNICATIONS.TAB-TTS-TYPE'));
      const templateUId = this.template?.communicationTemplates?.find(
        c => c.channelUId === ChannelUIds.TwilioTtsChannelUId && c.channelType === ChannelType.TextToSpeech
      )?.uId;
      this.contentTabChannels.push({
        channelUId: ChannelUIds.TwilioTtsChannelUId,
        channelType: ChannelType.TextToSpeech,
        icon: this.channelSelectionService.getChannelIcon(ChannelUIds.TwilioTtsChannelUId),
        templateUId: templateUId
      });
      this.contentTabIcons.push(this.channelSelectionService.getChannelIcon(ChannelUIds.TwilioTtsChannelUId));
    }

    if (hasWhatsapp) {
      this.contentTabs.push(this.translateService.instant('COMMUNICATIONS.TAB-WHATSAPP-TYPE'));
      const templateUId = this.template?.communicationTemplates?.find(
        c => c.channelUId === ChannelUIds.WhatsAppChannelUId && c.channelType === ChannelType.Sms
      )?.uId;
      this.contentTabChannels.push({
        channelUId: ChannelUIds.WhatsAppChannelUId,
        channelType: ChannelType.WhatsApp,
        icon: this.channelSelectionService.getChannelIcon(ChannelUIds.WhatsAppChannelUId),
        templateUId: templateUId
      });
      this.contentTabIcons.push(this.channelSelectionService.getChannelIcon(ChannelUIds.WhatsAppChannelUId));
    }

    if (hasPush) {
      this.contentTabs.push(this.translateService.instant('COMMUNICATIONS.TAB-PUSH-TYPE'));
      const templateUId = this.template?.communicationTemplates?.find(c => c.channelUId === ChannelUIds.HorizonMobilePushChannelUId)?.uId;
      this.contentTabChannels.push({
        channelUId: ChannelUIds.HorizonMobilePushChannelUId,
        channelType: ChannelType.MobilePush,
        icon: this.channelSelectionService.getChannelIcon(ChannelUIds.HorizonMobilePushChannelUId),
        templateUId: templateUId
      });
      this.contentTabIcons.push(this.channelSelectionService.getChannelIcon(ChannelUIds.HorizonMobilePushChannelUId));
    }

    if (hasGwts) {
      this.contentTabs.push(this.translateService.instant('COMMUNICATIONS.TAB-GWTS'));
      const templateUId = this.template?.communicationTemplates?.find(c => c.channelUId === ChannelUIds.GwtsMobileChannelUId)?.uId;
      this.contentTabChannels.push({
        channelUId: ChannelUIds.GwtsMobileChannelUId,
        channelType: ChannelType.MobilePush,
        icon: this.channelSelectionService.getChannelIcon(ChannelUIds.GwtsMobileChannelUId),
        templateUId: templateUId
      });
      this.contentTabIcons.push(this.channelSelectionService.getChannelIcon(ChannelUIds.GwtsMobileChannelUId));
    }
  }

  tabChanged(index: number): void {
    this.selectedTabIndex = index;
  }

  notificationTabChanged(index: number): void {
    this.selectedNotificationTabIndex = index;
  }
  get isSmsTab(): boolean {
    return (
      this.selectedCommunicationTemplate?.channelUId === ChannelUIds.TwilioChannelUId ||
      this.selectedCommunicationTemplate?.channelUId === ChannelUIds.HorizonSmsChannelUId
    );
  }

  contentTabChanged(index: number): void {
    this.selectedContentTabIndex = index;
    const contentChannel = this.contentTabChannels[index - 1];

    this.currentControlToEdit = null;
    this.showEmailSubject = false;
    this.showEmailSubject = false;

    if (!!!contentChannel) {
      return;
    }
    if (!!contentChannel?.templateUId) {
      this.selectedCommunicationTemplate = this.template?.communicationTemplates?.find(c => c.uId === contentChannel.templateUId);
    } else {
      this.selectedCommunicationTemplate = this.template?.communicationTemplates?.find(
        c => c.channelUId === contentChannel.channelUId && c.channelType === contentChannel.channelType
      );
      contentChannel.templateUId = this.selectedCommunicationTemplate?.uId;
    }

    this.currentChannelName = this.contentTabs[index];
    this.currentElementName = null;

    this.showEmailSubject =
      index > 0 &&
      (contentChannel.channelUId === ChannelUIds.SendGridEmailChannelUId || contentChannel.channelUId === ChannelUIds.TopoEmailChannelUId);

    if (this.showEmailSubject) {
      this.emailSubject = this.templateDesignerService.getTranslateText(
        this.selectedCommunicationTemplate?.settings?.emailSubject,
        this.selectedCulture
      );
    }

    this.showPushTitle =
      index > 0 &&
      (contentChannel.channelUId === ChannelUIds.HorizonMobilePushChannelUId ||
        contentChannel.channelUId === ChannelUIds.GwtsMobileChannelUId);

    this.showPushSummary = index > 0 && contentChannel.channelUId === ChannelUIds.HorizonMobilePushChannelUId;

    if (this.showPushTitle) {
      this.pushTitle = this.templateDesignerService.getTranslateText(
        this.selectedCommunicationTemplate?.settings?.emailSubject,
        this.selectedCulture
      );
    }
    if (this.showPushSummary) {
      this.pushSummary = this.templateDesignerService.getTranslateText(
        this.selectedCommunicationTemplate?.settings?.summary,
        this.selectedCulture
      );
    }

    if (!!!this.selectedCommunicationTemplate) {
      this.selectedCommunicationTemplate = {
        uId: uuidv4(),
        name: '',
        description: '',
        channelUId: contentChannel.channelUId,
        channelType: contentChannel.channelType,
        viewControls: []
      };
      contentChannel.templateUId = this.selectedCommunicationTemplate.uId;

      const updatedTemplate = produce(this.template, draftState => {
        if (!!!draftState.communicationTemplates) {
          draftState.communicationTemplates = [];
        }
        draftState.communicationTemplates.push(this.selectedCommunicationTemplate);
      });

      this.updateTemplate(updatedTemplate);
    }
  }

  private getSelectedDefaultMessageSettings(): void {
    this.selectedDefaultMessage = this.templateDesignerService.getTranslateText(
      this.template?.defaultMessageSettings?.notificationMessage,
      this.selectedCulture
    );
    this.selectedDefaultSmsMessage = this.templateDesignerService.getTranslateText(
      this.template?.defaultMessageSettings?.smsNotificationMessage,
      this.selectedCulture
    );
    this.selectedConfirmationMessage = this.templateDesignerService.getTranslateText(
      this.template?.defaultMessageSettings?.confirmationText,
      this.selectedCulture
    );
    this.confirmationButtons = [];
    let index = 0;
    this.template?.defaultMessageSettings?.confirmationButtons?.forEach(b => {
      index++;
      this.confirmationButtons.push({
        uId: b.uId ?? uuidv4(),
        number: b.number ?? index,
        type: b.type,
        text: this.templateDesignerService.getTranslateText(b.text, this.selectedCulture)
      });
    });

    const mainText = this.hasHTMLMessage ? this.getMessageCleanText(this.selectedDefaultMessage) : this.selectedDefaultSmsMessage;

    if (!this.userToggledSingleMessageMode) {
      this.singleMessageMode = true;

      if (mainText?.length !== this.selectedDefaultSmsMessage?.length) {
        this.singleMessageMode = false;
      } else {
        if (mainText?.length > 0 && this.selectedDefaultSmsMessage?.length > 0) {
          if (mainText !== this.selectedDefaultSmsMessage) {
            this.singleMessageMode = false;
          }
        }
      }
    }

    this.messageCharCount = mainText?.length;
    this.smsMessageCharCount = this.selectedDefaultSmsMessage?.length;
  }

  setSingleMessageMode(useSeparateSmsMsg: boolean): void {
    this.userToggledSingleMessageMode = true;

    this.singleMessageMode = !useSeparateSmsMsg;
    if (this.singleMessageMode) {
      this.generateSmsForSingleMessageMode();
    }
  }

  private generateSmsForSingleMessageMode(): void {
    if (!!!this.template) {
      return;
    }
    const updatedTemplate = produce(this.template, draftState => {
      if (!!!draftState.defaultMessageSettings) {
        draftState.defaultMessageSettings = {
          notificationMessage: {} as TextValueByCulture,
          smsNotificationMessage: {} as TextValueByCulture,
          confirmationText: {} as TextValueByCulture,
          confirmationButtons: []
        };
      }
      if (!!!draftState.defaultMessageSettings.notificationMessage) {
        draftState.defaultMessageSettings.notificationMessage = {} as TextValueByCulture;
      }

      if (this.singleMessageMode === true) {
        if (!!!draftState.defaultMessageSettings.smsNotificationMessage) {
          draftState.defaultMessageSettings.smsNotificationMessage = {} as TextValueByCulture;
        }
        if (!!this.template?.defaultMessageSettings?.notificationMessage) {
          const cleanText = this.getMessageCleanText(this.template?.defaultMessageSettings?.notificationMessage[this.selectedCulture]);
          draftState.defaultMessageSettings.smsNotificationMessage[this.selectedCulture] = cleanText;
          this.selectedDefaultSmsMessage = cleanText;
        }
      }
    });

    this.updateTemplate(updatedTemplate);
  }

  private getMessageCleanText(htmlText: string): string {
    if (!!!htmlText) {
      return null;
    }
    const regex = /(<([^>]+)>)/gi;
    return htmlText
      .replace(/<\/p>/g, ' ')
      .replace(/<\/br>/g, ' ')
      .replace(regex, '')
      .replace(/&nbsp;/g, ' ');
  }

  close(): void {
    if (this.isDirty === true) {
      this.showConfirmClose = true;
    } else {
      this.store.dispatch(fromComm.setSelectedMassNotificationTemplate({ template: null, isDirty: false }));
    }
  }

  onConfirmClose(response: boolean): void {
    if (response) {
      this.store.dispatch(fromComm.setSelectedMassNotificationTemplate({ template: null, isDirty: false }));
    }
    this.showConfirmClose = false;
  }

  onConfirmValidation(response: boolean): void {
    this.showConfirmValidation = false;

    if (this.isConfirmWarning) {
      if (response === true) {
        this.continueSaveAndClose(this.isClosing);
      }
    }
  }

  onSaveAndClose(): void {
    this.saveAndClose(true);
  }

  onSave(): void {
    this.actionsMenu?.hideMenu();
    this.saveMenuOpen = false;
    this.saveAndClose(false);
  }

  private saveAndClose(close: boolean): void {
    this.validationList = [];

    this.isClosing = close;
    this.preventSavingTemplate = false;

    if (
      !!!this.selectedNotificationWorkflowTemplateUId ||
      !this.notificationWorkflowTemplates?.find(t => t.uId === this.selectedNotificationWorkflowTemplateUId)
    ) {
      this.validationList.push(this.translateService.instant('COMMUNICATIONS.VALIDATION-ERROR-NOTIFICATION-WF-TEMPLATE-REQUIRED'));
    }

    if (
      !!!this.selectedRecipientWorkflowTemplateUId ||
      !this.recipientWorkflowTemplates?.find(t => t.uId === this.selectedRecipientWorkflowTemplateUId)
    ) {
      this.validationList.push(this.translateService.instant('COMMUNICATIONS.VALIDATION-ERROR-RECIPIENT-WF-TEMPLATE-REQUIRED'));
    }

    if (this.validationList.length) {
      this.validationMessage = this.translateService.instant('COMMUNICATIONS.VALIDATION-TEMPLATE-ERROR-MESSAGE');
      this.isConfirmWarning = false;
      this.showConfirmValidation = true;
      return;
    }

    for (var tabChannel of this.contentTabChannels) {
      let commTemplate = this.templateDesignerService.getCommunicationTemplateByChannelUId(this.template, tabChannel.channelUId);

      if (!!!commTemplate || !(commTemplate.viewControls?.length > 0)) {
        const name = this.channelSelectionService.getChannelName(tabChannel.channelUId);
        this.validationList.push(this.translateService.instant('COMMUNICATIONS.VALIDATION-TEMPLATE-WARNING-DESIGN-EMPTY', { name: name }));
      }
    }

    for (var commTemplate of this.template?.communicationTemplates) {
      if (!!commTemplate) {
        if (
          commTemplate.channelUId === ChannelUIds.SendGridEmailChannelUId ||
          commTemplate.channelUId === ChannelUIds.TopoEmailChannelUId
        ) {
          const templateSubject = this.templateDesignerService.getTranslateText(commTemplate.settings?.emailSubject, this.selectedCulture);
          if (!!!templateSubject) {
            this.validationList.push(this.translateService.instant('COMMUNICATIONS.VALIDATION-WARNING-EMAIL-SUBJECT-EMPTY'));  
          }
        }
        
        if (commTemplate.channelUId === ChannelUIds.HorizonMobilePushChannelUId) {
          const templateSubject = this.templateDesignerService.getTranslateText(commTemplate.settings?.emailSubject, this.selectedCulture)?.trim();
          const templateSummary = this.templateDesignerService.getTranslateText(commTemplate.settings?.summary, this.selectedCulture)?.trim();
          
          if (!templateSubject?.length) { 
            this.validationList.push(this.translateService.instant('COMMUNICATIONS.VALIDATION-ERROR-TITLE-REQUIRED'));
          }

          if (!templateSummary?.length) {
            this.validationList.push(this.translateService.instant('COMMUNICATIONS.VALIDATION-ERROR-SUMMARY-REQUIRED'))
          }

          if (!templateSubject?.length || !templateSummary?.length) {
            this.preventSavingTemplate = true;
          }
        }
      }
    }

    if (this.validationList.length) {
      const validationMessageKey = this.preventSavingTemplate ? 'VALIDATION-ERROR-MESSAGE' : 'VALIDATION-TEMPLATE-WARNING-MESSAGE';
      this.validationMessage = this.translateService.instant(`COMMUNICATIONS.${validationMessageKey}`);
      this.isConfirmWarning = true;
      this.showConfirmValidation = true;
      return;
    }

    this.continueSaveAndClose(close);
  }

  private continueSaveAndClose(close: boolean): void {
    if (!(this.templateName?.trim().length > 0)) {
      this.templateName = this.translateService.instant('COMMUNICATIONS.NOTIFICATION-TEMPLATE');
    }

    let overrides: AllowedTemplateOverrides = AllowedTemplateOverrides.None;
    if (this.canChangeChannels) {
      overrides |= AllowedTemplateOverrides.Channels;
    }
    if (this.canChangeCascade) {
      overrides |= AllowedTemplateOverrides.Cascade;
    }
    if (this.canChangeSendTime) {
      overrides |= AllowedTemplateOverrides.SendTime;
    }
    if (this.canChangeResendTime) {
      overrides |= AllowedTemplateOverrides.ResendTime;
    }
    if (this.canChangeExpiration) {
      overrides |= AllowedTemplateOverrides.Expiration;
    }
    if (this.canChangeMessage) {
      overrides |= AllowedTemplateOverrides.NotificationMessage;
    }
    if (this.canChangeRecipients) {
      overrides |= AllowedTemplateOverrides.Recipients;
    }

    const template: MassNotificationTemplate = {
      ...this.template,
      name: this.templateName,
      description: this.templateDesc,
      isActive: this.isTemplateActive,
      allowedOverrides: overrides,
      type: this.selectedTemplateType,
      templateGroupUId: this.selectedTemplateGroupUId ?? GUID_EMPTY,
      massNotificationWorkflowUId: this.selectedNotificationWorkflowTemplateUId ?? GUID_EMPTY,
      massNotificationRecipientsWorkflowUId: this.selectedRecipientWorkflowTemplateUId ?? GUID_EMPTY
    };

    const uniqueChannelUIds = this.channelSelectionService.getUniqueChannelUIds(template?.channelsCascadeSettings);

    const cleanTemplate = produce(template, draftState => {
      draftState.communicationTemplates?.forEach(c => {
        if (c.channelUId === ChannelUIds.TopoEmailChannelUId || c.channelUId === ChannelUIds.SendGridEmailChannelUId) {
          if (
            !uniqueChannelUIds.includes(ChannelUIds.TopoEmailChannelUId) &&
            !uniqueChannelUIds.includes(ChannelUIds.SendGridEmailChannelUId)
          ) {
            const index = draftState.communicationTemplates.findIndex(cc => cc.uId == c.uId);
            draftState.communicationTemplates?.splice(index, 1);
          }
        } else if (c.channelUId === ChannelUIds.TwilioChannelUId || c.channelUId === ChannelUIds.HorizonSmsChannelUId) {
          if (!uniqueChannelUIds.includes(ChannelUIds.TwilioChannelUId) && !uniqueChannelUIds.includes(ChannelUIds.HorizonSmsChannelUId)) {
            const index = draftState.communicationTemplates.findIndex(cc => cc.uId == c.uId);
            draftState.communicationTemplates?.splice(index, 1);
          }
        } else if (!uniqueChannelUIds.includes(c.channelUId)) {
          const index = draftState.communicationTemplates.findIndex(cc => cc.uId == c.uId);
          draftState.communicationTemplates?.splice(index, 1);
        }
      });
      const nullIndex = draftState.channelsCascadeSettings?.channelNotifications?.indexOf(null);
      if (nullIndex >= 0) {
        draftState.channelsCascadeSettings?.channelNotifications?.splice(nullIndex, 1);
      }
      draftState.businessUnitUIds = this.selectedUnitUIds;
    });

    this.store.dispatch(fromComm.saveSelectedMassNotificationTemplate({ close, template: cleanTemplate }));
  }

  drawerOpenClose(open: boolean): void {
    this.isDrawerOpen = open;
  }

  templateTypeSelected(templateType: MassNotificationType): void {
    this.selectedTemplateType = templateType;
    this.disabledElementTypes = templateType === MassNotificationType.Announcement ? [TemplateViewControlType.ConfirmationMessage] : [];
    //if template type  changed from confirmation to annoucement  update the designer
    //to remove all view controls conformation elements

    if (
      this.selectedTemplateType == MassNotificationType.Announcement &&
      this.template.communicationTemplates?.find(c =>
        c.viewControls.filter(x => x.controlType == TemplateViewControlType.ConfirmationMessage)
      )
    ) {
      const updatedTemplate = produce(this.template, draftState => {
        if (!!!draftState.defaultMessageSettings) {
          draftState.defaultMessageSettings = {
            notificationMessage: {} as TextValueByCulture,
            smsNotificationMessage: {} as TextValueByCulture,
            confirmationText: {} as TextValueByCulture,
            confirmationButtons: []
          };
        }
        if (!!!draftState.defaultMessageSettings.confirmationText) {
          draftState.defaultMessageSettings.confirmationText = {} as TextValueByCulture;
        }

        draftState.communicationTemplates?.forEach(template => {
          template.viewControls = template.viewControls.filter(
            control => control.controlType !== TemplateViewControlType.ConfirmationMessage
          );
        });
      });

      this.cdr.detectChanges();

      this.updateTemplate(updatedTemplate);
    }

    this.setChanged();
  }

  setChanged(): void {
    this.store.dispatch(fromComm.setMassNotificationTemplatesIsDirty({ isDirty: true }));
  }

  isSafetyCheckType(): boolean {
    return this.selectedTemplateType === MassNotificationType.SafetyCheck;
  }

  channelSelectionChanged(settings: ChannelsCascadeSettings): void {
    const newTemplate = produce(this.template, draftState => {
      draftState.channelsCascadeSettings = settings;
    });

    this.updateTemplate(newTemplate);

    this.getMessageTypes();
    this.syncContentTabs(newTemplate);
    this.contentTabChanged(this.selectedContentTabIndex);
  }

  templateDesignChanged(template: CommunicationTemplate): void {
    const newTemplate = produce(this.template, draftState => {
      const commTemplate = draftState.communicationTemplates?.find(c => c.uId === template.uId);
      if (!!commTemplate) {
        commTemplate.viewControls = template.viewControls;
      }
    });

    this.updateTemplate(newTemplate);
  }

  emailSubjectChanged(event: any): void {
    const updatedTemplate = produce(this.template, draftState => {
      const comTemplate = draftState?.communicationTemplates?.find(c => c.uId === this.selectedCommunicationTemplate?.uId);

      if (!!comTemplate) {
        if (!comTemplate.settings) {
          comTemplate.settings = {};
        }

        if (!comTemplate.settings.emailSubject) {
          comTemplate.settings.emailSubject = {} as TextValueByCulture;
        }

        comTemplate.settings.emailSubject[this.selectedCulture] = event;
      }
    });

    this.updateTemplate(updatedTemplate);
  }

  pushTitleChanged(event: any): void {
    const updatedTemplate = produce(this.template, draftState => {
      const comTemplate = draftState?.communicationTemplates?.find(c => c.uId === this.selectedCommunicationTemplate?.uId);

      if (!!comTemplate) {
        if (!comTemplate.settings) {
          comTemplate.settings = {};
        }

        if (!comTemplate.settings.emailSubject) {
          comTemplate.settings.emailSubject = {} as TextValueByCulture;
        }

        comTemplate.settings.emailSubject[this.selectedCulture] = event;
      }
    });

    this.updateTemplate(updatedTemplate);
  }

  pushSummaryChanged(event: any): void {
    const updatedTemplate = produce(this.template, draftState => {
      const comTemplate = draftState?.communicationTemplates?.find(c => c.uId === this.selectedCommunicationTemplate?.uId);

      if (!!comTemplate) {
        if (!comTemplate.settings) {
          comTemplate.settings = {};
        }

        if (!comTemplate.settings.summary) {
          comTemplate.settings.summary = {} as TextValueByCulture;
        }

        comTemplate.settings.summary[this.selectedCulture] = event;
      }
    });

    this.updateTemplate(updatedTemplate);
  }

  templateDesignControlSelected(event: SelectedElementEvent): void {
    const registration = TemplateDesignElementsRegistration.find(
      r => r.channelUId === this.selectedCommunicationTemplate.channelUId && r.viewControlType == event.control.controlType
    );
    this.currentElementName = this.translateService.instant(registration?.desc);

    if (
      event.control.controlType === TemplateViewControlType.Image ||
      event.control.controlType === TemplateViewControlType.Text ||
      event.control.controlType === TemplateViewControlType.Header ||
      event.control.controlType === TemplateViewControlType.Map ||
      event.control.controlType === TemplateViewControlType.FormField ||
      (event.control.controlType === TemplateViewControlType.ConfirmationMessage &&
        this.selectedCommunicationTemplate?.channelUId !== ChannelUIds.TwilioTtsChannelUId &&
        this.selectedCommunicationTemplate?.channelUId !== ChannelUIds.WhatsAppChannelUId)
    ) {
      this.currentControlToEdit = event.control;
    } else {
      this.currentControlToEdit = null;
    }
  }

  hideSettings(): void {
    this.currentControlToEdit = null;
    this.designer?.clearSelected();
  }

  templateDesignControlDeleted(event: SelectedElementEvent): void {
    const newTemplate = produce(this.template, draftState => {
      const commTemplate = draftState.communicationTemplates?.find(c => c.uId === event.template.uId);
      if (!!commTemplate) {
        const index = commTemplate.viewControls?.findIndex(c => c.uId === event.control.uId);
        if (index >= 0) {
          commTemplate.viewControls.splice(index, 1);
        }
      }
    });

    this.updateTemplate(newTemplate);
  }

  templateDesignControlEdited(event: SelectedElementEvent): void {
    const designControl = this.designControls._results.find(c => c._control.uId === event.control.uId);
    if (designControl) {
      designControl.edit();
    }
  }

  templateDesignControlChanged(data: { template: CommunicationTemplate; control: CommunicationTemplateViewControl; settings: any }): void {
    const selectedTemplate = this.selectedCommunicationTemplate;

    const updatedTemplate = produce(this.template, draftState => {
      const commTemplate = draftState.communicationTemplates?.find(t => t.uId === selectedTemplate?.uId);
      const updateControl = commTemplate.viewControls?.find(c => c.uId === data.control.uId);
      if (!!updateControl) {
        updateControl.settings = data.settings;
      }
    });

    this.updateTemplate(updatedTemplate);

    if (!!this.currentControlToEdit && this.currentControlToEdit.uId === data.control.uId) {
      this.currentControlToEdit.settings = data.settings;
      const designControls = this.designControls._results.filter(c => c._control.uId === data.control.uId);
      designControls?.forEach(c => {
        c.loadSettings();
      });
    }
  }

  private loadWorkflowTemplates(): void {
    this.getWorkflowTemplates()
      .pipe(take(1))
      .subscribe(data => {
        this.notificationWorkflowTemplates = data.filter(t => t.parentType === WorkflowParentType.MassNotification);
        this.recipientWorkflowTemplates = data.filter(t => t.parentType === WorkflowParentType.MassNotificationRecipient);

        if (
          this.notificationWorkflowTemplates?.length > 0 &&
          !this.notificationWorkflowTemplates.find(t => t.uId === this.selectedNotificationWorkflowTemplateUId)
        ) {
          this.selectedNotificationWorkflowTemplateUId = this.notificationWorkflowTemplates.find(t => t.isDefault === true)?.uId;
          if (!!!this.selectedNotificationWorkflowTemplateUId) {
            this.selectedNotificationWorkflowTemplateUId = this.notificationWorkflowTemplates[0].uId;
          }
        }
        if (
          this.recipientWorkflowTemplates?.length > 0 &&
          !this.recipientWorkflowTemplates.find(t => t.uId === this.selectedRecipientWorkflowTemplateUId)
        ) {
          this.selectedRecipientWorkflowTemplateUId = this.recipientWorkflowTemplates.find(t => t.isDefault === true)?.uId;
          if (!!!this.selectedRecipientWorkflowTemplateUId) {
            this.selectedRecipientWorkflowTemplateUId = this.recipientWorkflowTemplates[0].uId;
          }
        }
      });
  }

  private getWorkflowTemplates(): Observable<Workflow[]> {
    const params: QueryParams = {
      skip: 0,
      take: 1000,
      where: `IsActive=true && (ParentType=${WorkflowParentType.MassNotification} OR ParentType=${WorkflowParentType.MassNotificationRecipient})`,
      sortField: 'Name',
      sortDirection: 'Ascending'
    };
    return this.workflowApiService.getWorkflows(params, false).pipe(
      catchError(() => of({ data: [] })),
      map(({ data }) => {
        return data;
      })
    );
  }

  private loadTemplateGroups(): void {
    this.getTemplateGroups()
      .pipe(take(1))
      .subscribe(data => {
        this.templateGroups = data;
        if (this.templateGroups?.length > 0 && !this.templateGroups.find(t => t.uId === this.selectedTemplateGroupUId)) {
          this.selectedTemplateGroupUId = null;
        }
      });
  }

  private getTemplateGroups(): Observable<MassNotificationTemplateGroup[]> {
    const params: QueryParams = {
      skip: 0,
      take: 1000,
      where: ``,
      sortField: 'Name',
      sortDirection: 'Ascending'
    };
    return this.commApiService.getMassNotificationTemplateGroups(params).pipe(
      catchError(() => of({ data: [] })),
      map(({ data }) => {
        return data;
      })
    );
  }

  smsNotificationMessageUpdated(event: any) {
    this.smsMessageCharCount = event.srcElement?.value?.length;
  }

  smsNotificationMessageChanged(event: any) {
    this.smsMessageCharCount = event.length;

    // Enforce absolute maximum limit if enabled
    if (this.blockInput && this.smsMessageCharCount > this.absoluteMaxLimit) {
      this.selectedDefaultSmsMessage = event.substring(0, this.absoluteMaxLimit);
      this.smsMessageCharCount = this.absoluteMaxLimit;
    }

    const updatedTemplate = produce(this.template, draftState => {
      if (!!!draftState.defaultMessageSettings) {
        draftState.defaultMessageSettings = {
          notificationMessage: {} as TextValueByCulture,
          smsNotificationMessage: {} as TextValueByCulture,
          confirmationText: {} as TextValueByCulture,
          confirmationButtons: []
        };
      }
      if (!!!draftState.defaultMessageSettings.smsNotificationMessage) {
        draftState.defaultMessageSettings.smsNotificationMessage = {} as TextValueByCulture;
      }
      draftState.defaultMessageSettings.smsNotificationMessage[this.selectedCulture] = event;
    });

    this.updateTemplate(updatedTemplate);
  }

  trackByButtons(index, item) {
    return index;
  }

  confirmationTextChanged(event: any): void {
    const updatedTemplate = produce(this.template, draftState => {
      if (!!!draftState.defaultMessageSettings) {
        draftState.defaultMessageSettings = {
          notificationMessage: {} as TextValueByCulture,
          smsNotificationMessage: {} as TextValueByCulture,
          confirmationText: {} as TextValueByCulture,
          confirmationButtons: []
        };
      }
      if (!!!draftState.defaultMessageSettings.confirmationText) {
        draftState.defaultMessageSettings.confirmationText = {} as TextValueByCulture;
      }
      draftState.defaultMessageSettings.confirmationText[this.selectedCulture] = event;
    });

    this.cdr.detectChanges();

    this.updateTemplate(updatedTemplate);
  }

  confirmationButtonChanged(index: number, event: any): void {
    const updatedTemplate = produce(this.template, draftState => {
      if (!!!draftState.defaultMessageSettings) {
        draftState.defaultMessageSettings = {
          notificationMessage: {} as TextValueByCulture,
          smsNotificationMessage: {} as TextValueByCulture,
          confirmationText: {} as TextValueByCulture,
          confirmationButtons: []
        };
      }

      if (!!!draftState.defaultMessageSettings.confirmationButtons[index]) {
        draftState.defaultMessageSettings.confirmationButtons[index] = {
          uId: uuidv4(),
          number: index + 1,
          text: null,
          type: ConfirmationType.Positive
        };
      }

      draftState.defaultMessageSettings.confirmationButtons[index].text[this.selectedCulture] = event;
    });

    this.cdr.detectChanges();

    this.updateTemplate(updatedTemplate);
  }

  confirmationButtonActionChanged(index: number, event: any): void {
    const updatedTemplate = produce(this.template, draftState => {
      if (!!!draftState.defaultMessageSettings) {
        draftState.defaultMessageSettings = {
          notificationMessage: {} as TextValueByCulture,
          smsNotificationMessage: {} as TextValueByCulture,
          confirmationText: {} as TextValueByCulture,
          confirmationButtons: []
        };
      }
      if (!!!draftState.defaultMessageSettings.confirmationButtons) {
        draftState.defaultMessageSettings.confirmationButtons = [];
      }
      draftState.defaultMessageSettings.confirmationButtons[index].type =
        event === '1' ? ConfirmationType.Positive : ConfirmationType.Negative;
    });

    this.cdr.detectChanges();

    this.updateTemplate(updatedTemplate);
  }

  addConfirmationButtonClick() {
    const updatedTemplate = produce(this.template, draftState => {
      if (!!!draftState.defaultMessageSettings) {
        draftState.defaultMessageSettings = {
          notificationMessage: {} as TextValueByCulture,
          smsNotificationMessage: {} as TextValueByCulture,
          confirmationText: {} as TextValueByCulture,
          confirmationButtons: []
        };
      }
      if (!!!draftState.defaultMessageSettings.confirmationButtons) {
        draftState.defaultMessageSettings.confirmationButtons = [];
      }
      var index = draftState.defaultMessageSettings.confirmationButtons.length + 1;
      const newButton = { uId: uuidv4(), number: index, text: {}, type: ConfirmationType.Positive } as ConfirmationButton;
      draftState.defaultMessageSettings.confirmationButtons.push(newButton);
    });

    this.cdr.detectChanges();

    this.updateTemplate(updatedTemplate);
  }

  deleteConfirmationButtonClick(index: number) {
    const updatedTemplate = produce(this.template, draftState => {
      draftState.defaultMessageSettings.confirmationButtons.splice(index, 1);
    });

    this.updateTemplate(updatedTemplate);
  }

  getUserList(searchText, renderList) {
    this.userProfileApiService.getUsersForMention(this.organizationUId, searchText).subscribe(res => {
      const entries = res.data.map(p => ({ id: p.uId, value: `${p.displayName}` }));
      renderList(entries);
    });
  }

  onDesignElementEdit(control: CommunicationTemplateViewControl): void {
    this.currentElementName = this.translateService.instant('COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + control.controlType);
    if (
      control.controlType === TemplateViewControlType.Image ||
      control.controlType === TemplateViewControlType.Text ||
      control.controlType === TemplateViewControlType.Header ||
      control.controlType === TemplateViewControlType.Map ||
      control.controlType === TemplateViewControlType.FormField ||
      (control.controlType === TemplateViewControlType.ConfirmationMessage &&
        this.selectedCommunicationTemplate?.channelUId !== ChannelUIds.TwilioTtsChannelUId &&
        this.selectedCommunicationTemplate?.channelUId !== ChannelUIds.WhatsAppChannelUId)
    ) {
      this.currentControlToEdit = control;
    } else {
      this.currentControlToEdit = null;
    }
  }

  onDesignerClicked(event: any): void {
    if (event.srcElement?.id === 'designer-container') {
      this.currentControlToEdit = null;
      this.showEmailSubject =
        this.selectedCommunicationTemplate?.channelUId === ChannelUIds.SendGridEmailChannelUId ||
        this.selectedCommunicationTemplate?.channelUId === ChannelUIds.TopoEmailChannelUId;
    }
  }

  selectedControlChanged(data: { uId: string; settings: any }) {
    const selectedTemplate = this.selectedCommunicationTemplate;

    const updatedTemplate = produce(this.template, draftState => {
      const commTemplate = draftState.communicationTemplates?.find(t => t.uId === selectedTemplate?.uId);
      const updateControl = commTemplate.viewControls?.find(c => c.uId === data.uId);
      if (!!updateControl) {
        updateControl.settings = data.settings;
      }
    });

    this.cdr.detectChanges();

    this.updateTemplate(updatedTemplate);
  }

  getLanguageDisplay(lang: string) {
    if (!!lang) {
      return this.translateService.instant(`LANGUAGES.LANGUAGE-${lang}`);
    }
    return '';
  }

  cultureChanged(): void {
    const currentControlToEdit = this.currentControlToEdit;
    this.contentTabChanged(this.selectedContentTabIndex);
    this.getSelectedDefaultMessageSettings();
    this.currentControlToEdit = currentControlToEdit;
  }

  showSaveMenu(event: PointerEvent): void {
    if (!!!this.saveMenuOpen) {
      this.actionsMenu?.showMenu(event.pageX, event.pageY);
      this.saveMenuOpen = true;
    } else {
      this.actionsMenu?.hideMenu();
      this.saveMenuOpen = false;
    }
  }

  onRecipientsTabSelected(): void {
    this.recipientsSelectionActive = true;
  }
  recipientsSelected(data: any): void {}

  recipientsClosed(): void {
    this.recipientsSelectionActive = false;
  }

  onSettingsTabSelected(): void {
    this.mainTabIndex = 0;
    this.currentElementName = this.translateService.instant('COMMUNICATIONS.TAB-NOTIFICATION-MESSAGE');
    this.currentChannelName = null;
    this.currentControlToEdit = null;
    this.showEmailSubject = false;
    this.selectedNotificationTabIndex = 0;
  }

  onTemplatesTabSelected(): void {
    this.mainTabIndex = 1;
    this.selectedContentTabIndex = 0;
    this.contentTabChanged(this.selectedContentTabIndex);
    this.selectedNotificationTabIndex = 0;
  }

  get editorModules() {
    this.editorService.init();
    return {
      toolbar: {
        container: [
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          [{ 'font': [] }],
          [{ 'align': [] }],
          ['blockquote'],
          ['link'],
          [{ 'indent': '-1' }, { 'indent': '+1' }],
          [{ 'color': [] }, { 'background': [] }],
          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ redo: 'redo' }, { undo: 'undo' }]
        ],
        handlers: {
          redo: () => {
            this.editor?.history.redo();
          },
          undo: () => {
            this.editor?.history.undo();
          }
        }
      },
      history: { delay: 2000, maxStack: 500, userOnly: true },
      mention: {
        minChars: 1,
        mentionDenotationChars: ['@'],
        source: (searchTerm, renderList) => {
          this.getUserList(searchTerm, renderList);
        }
      }
    };
  }

  editorCreated(editor: any) {
    this.editor = editor;
  }

  onEditorContentChanged(event: any) {
    var cleanText = this.getMessageCleanText(event.html);

    const updatedTemplate = produce(this.template, draftState => {
      if (!!!draftState.defaultMessageSettings) {
        draftState.defaultMessageSettings = {
          notificationMessage: {} as TextValueByCulture,
          smsNotificationMessage: {} as TextValueByCulture,
          confirmationText: {} as TextValueByCulture,
          confirmationButtons: []
        };
      }
      if (!!!draftState.defaultMessageSettings.notificationMessage) {
        draftState.defaultMessageSettings.notificationMessage = {} as TextValueByCulture;
      }
      draftState.defaultMessageSettings.notificationMessage[this.selectedCulture] = event.html;

      if (this.singleMessageMode === true) {
        if (!!!draftState.defaultMessageSettings.smsNotificationMessage) {
          draftState.defaultMessageSettings.smsNotificationMessage = {} as TextValueByCulture;
        }
        draftState.defaultMessageSettings.smsNotificationMessage[this.selectedCulture] = cleanText;
        this.selectedDefaultSmsMessage = cleanText;
      }
    });

    this.updateTemplate(updatedTemplate);
  }

  selectedRecipientsChanged(settings: ToRecipientSettings): void {
    const updatedTemplate = produce(this.template, draftState => {
      if (!!!draftState.recipientSettings) {
        draftState.recipientSettings = {};
      }
      draftState.recipientSettings.recipients = settings.recipients;
      draftState.recipientSettings.datasetRecipients = [];
      settings.datasetRecipients?.forEach(r => {
        draftState.recipientSettings.datasetRecipients.push(r);
      });
    });

    this.updateTemplate(updatedTemplate);
  }

  getSelectedSettingsName(): string {
    if (this.selectedContentTabIndex == 0) {
      this.currentElementName = this.translateService.instant('COMMUNICATIONS.NOTIFICATION-MESSAGE');
      return this.currentElementName;
    }

    const names = [];
    if (!!this.currentChannelName) {
      names.push(this.currentChannelName);
    }
    if (!!this.currentElementName) {
      names.push(this.currentElementName);
    }

    return names.join(' / ');
  }

  preventInputWhenLimitReached(event: KeyboardEvent): boolean {
    if (!this.blockInput) return true;
    if (this.smsMessageCharCount < this.absoluteMaxLimit) return true;
    const allowedKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Home',
      'End',
      'Tab',
      'Control',
      'Shift',
      'Alt',
      'Meta'
    ];
    if (allowedKeys.includes(event.key) || event.ctrlKey || event.metaKey) {
      return true;
    }
    if (this.smsMessageCharCount >= this.absoluteMaxLimit) {
      event.preventDefault();
      return false;
    }

    return true;
  }

  getRemainingCharacters(): number {
    let remaining: number;
    if (this.isOverLimit()) {
      remaining = this.smsMessageCharCount - this.singleSmsLimit;
    } else {
      remaining = this.singleSmsLimit - this.smsMessageCharCount;
    }
    return isNaN(remaining) ? this.singleSmsLimit : remaining;
  }

  isApproachingLimit(): boolean {
    return this.smsMessageCharCount >= this.warningThreshold && this.smsMessageCharCount < this.singleSmsLimit;
  }

  isOverLimit(): boolean {
    return this.smsMessageCharCount >= this.singleSmsLimit;
  }

  getProgressValue(): number {
    const percentage = (this.smsMessageCharCount / this.singleSmsLimit) * 100;
    return Math.min(percentage, 100);
  }

  getProgressBarColor(): 'primary' | 'accent' | 'warn' {
    if (this.isOverLimit()) {
      return 'warn';
    }
    if (this.isApproachingLimit()) {
      return 'accent';
    }
    return 'primary';
  }

  // Use the public method to get current count
  get currentCount(): number {
    return this.templateDesignerService.getCurrentSmsCount();
  }

  // Update progress functions to use this.currentCount
  getDesignerProgressValue(): number {
    const ratio = this.currentCount / this.templateDesignerService.MAX_CHARS;
    return Math.min(ratio * 100, 100);
  }

  getDesignerProgressColor(): string {
    return this.isDesignerOverLimit() ? 'warn' : this.isDesignerApproachingLimit() ? 'accent' : 'primary';
  }

  isDesignerApproachingLimit(): boolean {
    return this.currentCount >= this.warningThreshold && this.currentCount <= this.templateDesignerService.MAX_CHARS;
  }

  isDesignerOverLimit(): boolean {
    this.isSmsOverLimitReached = this.currentCount > this.templateDesignerService.MAX_CHARS;
    return this.currentCount > this.templateDesignerService.MAX_CHARS;
  }

  getDesignerRemainingCharacters(): number {
    return Math.abs(this.currentCount - this.templateDesignerService.MAX_CHARS);
  }

  getTotalSmsUsageFromTemplate(template: any): number {
    // controlType NotificationMessage: count * smsMessage length
    let controlTypeNotificationMessageCount = 0;
    const smsTemplate = template?.communicationTemplates?.find((t: any) => t.channelType === ChannelType.Sms);
    controlTypeNotificationMessageCount =
      smsTemplate?.viewControls?.filter((vc: any) => vc.controlType === TemplateViewControlType.NotificationMessage).length || 0;
    const smsMessage = template?.defaultMessageSettings?.smsNotificationMessage?.[this.selectedCulture] || '';
    const smsLength = smsMessage.trim().length;
    const controlTypeNotificationMessageCountTotal = controlTypeNotificationMessageCount * smsLength;

    // controlType Text: sum of all Text lengths
    let controlTypeTextTotal = 0;
    controlTypeTextTotal =
      smsTemplate?.viewControls
        ?.filter((vc: any) => vc.controlType === TemplateViewControlType.Text)
        .reduce((sum: number, vc: any) => {
          const richText = vc.settings?.richText?.[this.selectedCulture] || '';
          return sum + richText.length;
        }, 0) || 0;

    // controlType ConfirmationMessage: count confirmation text and buttons only once
    let controlTypeConfirmationMessageTotal = 0;
    // Count how many controlType ConfirmationMessage controls exist
    let controlTypeConfirmationMessageCount = 0;
    controlTypeConfirmationMessageCount =
      smsTemplate?.viewControls?.filter((vc: any) => vc.controlType === TemplateViewControlType.ConfirmationMessage).length || 0;

    // Only add confirmation text and buttons once and translated label
    const confirmationText = template?.defaultMessageSettings?.confirmationText?.[this.selectedCulture] || '';
    controlTypeConfirmationMessageTotal += confirmationText.length;
    const buttons = template?.defaultMessageSettings?.confirmationButtons || [];
    let replyCounter = 1;
    buttons.forEach((btn: any) => {
      const btnText = btn.text?.[this.selectedCulture] || '';
      controlTypeConfirmationMessageTotal += btnText.length;
      controlTypeConfirmationMessageTotal +=
        (this.translateService.instant('COMMUNICATIONS.MESSAGE-REPLY') + ' ' + replyCounter + ': ').length;
    });

    return (
      controlTypeNotificationMessageCountTotal +
      controlTypeTextTotal +
      controlTypeConfirmationMessageTotal * controlTypeConfirmationMessageCount
    );
  }

  isOverTotalLimit(): boolean {
    const isOverLimit = this.getTotalSmsUsageFromTemplate(this.template) > this.MAX_CHARS;
    this.isSmsOverLimitReached$.next(isOverLimit);
    this.isSmsOverLimit = isOverLimit;
    return isOverLimit;
  }
}
